import { useState } from "react";

export default function LoginForm({ login }) {
  const {
    email, setEmail,
    password, setPassword,
    loading, handleLogin,
    setShowForgot, setStep,
    setFpEmail, setFpOtp
  } = login;

  const [showPass, setShowPass] = useState(false);

  return (
    <form onSubmit={handleLogin} className="dr-form">
      <div className="dr-input-group">
        <label className="dr-input-label">EMAIL ADDRESS</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="dr-input"
          required
        />
      </div>

      <div className="dr-input-group">
        <label className="dr-input-label">PASSWORD</label>
        <div style={{ position: "relative" }}>
          <input
            type={showPass ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="dr-input"
            required
            style={{ paddingRight: "42px" }}
          />
          <button
            type="button"
            onClick={() => setShowPass(p => !p)}
            style={{
              position: "absolute", right: "12px", top: "50%",
              transform: "translateY(-50%)", background: "none",
              border: "none", cursor: "pointer", fontSize: "18px",
              color: "#888", padding: 0, lineHeight: 1
            }}
            tabIndex={-1}
          >
            {showPass ? "🙈" : "👁️"}
          </button>
        </div>
      </div>

      <button className="dr-login-btn" disabled={loading}>
        {loading ? "Authenticating..." : "Sign In to Dashboard"}
      </button>

      <div className="dr-links">
        <a href="/register" className="dr-link">Create New Account</a>
        <span
          className="dr-link"
          onClick={() => {
            setShowForgot(true);
            setStep(1);
            setFpEmail("");
            setFpOtp("");
          }}
        >
          Forgot password?
        </span>
      </div>
    </form>
  );
}